import { render, staticRenderFns } from "./svg-parts-viewer.vue?vue&type=template&id=293ba6f6"
import script from "./svg-parts-viewer.vue?vue&type=script&lang=js"
export * from "./svg-parts-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports